module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\" ng-style=\"imageStyle\"></div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-ui-components/src/banner/template.html
 ** module id = 363
 ** module chunks = 1
 **/